import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'app-define-behavior-wizard-operational-definition-step',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzButtonModule,
    NzInputModule,
  ],
  templateUrl:
    './define-behavior-wizard-operational-definition-step.component.html',
})
export class DefineBehaviorWizardOperationalDefinitionStepComponent {
  @Input() form!: FormGroup;
  @Input() isRequired = false;
  @Input() onControlInputChange!: (
    event: Event,
    control: AbstractControl | null
  ) => void;
  @Output() openPdfModal = new EventEmitter<void>();
}
